exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pswp-thumbnails .pswp-thumbnail{font-size:0;cursor:pointer}", ""]);

// exports
